import { Table, Checkbox, Drawer, Button, Tooltip, Modal, Form, Input, Select, message,Collapse,Avatar,Tag,Tabs, Spin } from 'antd';
import { useState } from 'react';
import { LinkedinFilled, CopyOutlined,MailTwoTone, PhoneTwoTone } from '@ant-design/icons';
import { encryptData, decryptData } from '../middleware/encryption';
import { all } from 'axios';



const { Option } = Select;

const { TabPane } = Tabs;
const { Panel } = Collapse;

const handleCopy = (text) => {
  navigator.clipboard.writeText(text);
  message.success('Copied to clipboard!');
};

const handleSavedLeadsOk = async (leadId,field) => {
  try {


    
    // Get the token from session storage
    const token = sessionStorage.getItem('access_token');
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    
    if (token) {
      myHeaders.append('Authorization', `Bearer ${token}`);
    }

    // Dynamically construct the leadsArray based on user selection
    const leadsArray = [{
      leadId,
      email: field=='email'?true:false,
      mobile: field=='mobile_phone'?true:false,
      type: 'leads',
    }];

    // Prepare the payload to match the backend request
    const payload = {
      leads: leadsArray,
      type: 'leads' ,
    };

    

    // Encrypt the payload
    const encryptedData = encryptData(payload);
   

    // Prepare the request body with the encrypted data
    const requestBody = {
      data: encryptedData, // Backend expects the encrypted data wrapped in an object
    };

    // Send the POST request using fetch
    const response = await fetch('https://api.app.exellius.com/api/leads/saveLeads', {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(requestBody), // Convert the object to JSON string
      redirect: 'follow',
    });

    // Parse the JSON response and decrypt the data
    const result = await response.json();
    const decryptedResponse = decryptData(result.data);
    

    // Handle response based on status
    if (response.ok) {
      
      message.success('Leads saved successfully');
      
    } else {
      
      message.error(result.message || 'Failed to save leads');
    }
  } catch (error) {
    
    message.error('An error occurred while saving leads');
  } finally {
    
  }
};

const getColumns = (selectedFields, selectedKeys, handleSelect, handleSelectAll, handleNameClick, handleReveal, revealedContacts, handleCopy, showEditModal, showRevealModal, allSelectOptionAllowed, revealLoadingMap) => {

  const isFieldLoading = (id, field) => !!(revealLoadingMap && revealLoadingMap[id] && revealLoadingMap[id][field]);


  const maskValue = (value) => {
  if (!value) return '*****';

  const str = String(value);

  if (str.length <= 4) {
    return '*'.repeat(str.length);
  }

  return str.substring(0, 2) + '*'.repeat(str.length - 4) + str.substring(str.length - 2);
};

const role = sessionStorage.getItem('role');
  const shouldBlur = role !== 'admin';

 
  const columns = [
    {
    title: allSelectOptionAllowed ? (
      <Checkbox
        checked={selectedKeys.length !== 0}
        onChange={handleSelectAll}
      />
    ) : (
      <Tooltip title="Please apply a filter before using select all">
        <span>
          {/* Wrapping in <span> to avoid warning about disabled child of Tooltip */}
          <Checkbox
            disabled
            checked={selectedKeys.length !== 0}
            onChange={handleSelectAll}
          />
        </span>
      </Tooltip>
    ),
    key: 'select',
    fixed: 'left',
    width: 50,
    render: (_, record) => (
      <Checkbox
        checked={selectedKeys.includes(record.id)}
        onChange={() => handleSelect(record.id)}
      />
    ),
  },
  ];

  selectedFields.forEach(field => {
    columns.push({
      title: field === "mobile_phone" 
  ? "Phone" 
  : field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      dataIndex: field,
      key: field,
      fixed: field === 'name' ? 'left' : null,
      width: field === 'name' || field === 'company' || field==="mobile_phone" || field==='email' ? 200 : 150,
      sorter: (a, b) => {
        if (typeof a[field] === "number") {
          return a[field] - b[field]; // Numeric sorting
        } else if (typeof a[field] === "string") {
          return a[field].localeCompare(b[field]); // String sorting
        }
        return 0;
      },
      render: (text, record) => {

       


        if (field === 'name') {
          const isBlurred = shouldBlur && !(revealedContacts[record.id]?.email || revealedContacts[record.id]?.mobile_phone || record.isEmail || record.isMobile);
          
          return (
            <Tooltip title={isBlurred ? '' : text}>
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <a className='color-table-text' onClick={() => handleNameClick(record)}>{text}</a>
                {record[`linkedin_url`] && !isBlurred && (
                  <Tooltip title="Open LinkedIn">
                    <a className='color-table-text-active'  href={record[`linkedin_url`]} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
                      <LinkedinFilled style={{ fontSize: '14px' }} />
                    </a>
                  </Tooltip>
                )}
              </div>
            </Tooltip>
          );
        }

        if (field === 'company') {
          const isBlurred = shouldBlur && !(revealedContacts[record.id]?.email || revealedContacts[record.id]?.mobile_phone || record.isEmail || record.isMobile);
          return (
            <Tooltip title={isBlurred ? '' : text}>
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', filter: isBlurred ? 'blur(5px)' : 'none', userSelect: isBlurred ? 'none' : 'auto' }}>
                <a className='color-table-text' onClick={() => handleNameClick(record)}>{isBlurred?maskValue(text):text}</a>
                {record[`company_linkedin_url`] && !isBlurred && (
                  <Tooltip title="Open LinkedIn">
                    <a className='color-table-text-active' href={record[`company_linkedin_url`]} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
                      <LinkedinFilled style={{ fontSize: '14px' }} />
                    </a>
                  </Tooltip>
                )}
              </div>
            </Tooltip>
          );
        }

        if ((field === 'email' || field === 'mobile_phone') && role === 'admin') {
          if (field === 'email') {
            return (
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'default' }}>
                {text}
                <CopyOutlined onClick={() => handleCopy(text)} style={{ cursor: 'pointer', color: '#9856f2' }} />
              </span>
            );
          }

         return (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      flexWrap: 'wrap'
    }}
  >
    {text && <span>{text}</span>}

    {record['corporate_phone'] && (
      <span>{record['corporate_phone']}</span>
    )}

    {record['work_direct_phone'] && (
      <span>{record['work_direct_phone']}</span>
    )}
  </div>
);
        }

        if ((field === 'email' || field === 'mobile_phone') && role === 'user') {
          const isMobileRevealed = revealedContacts[record.id]?.mobile_phone || record.isMobile;
          const isCorporatePhoneRevealed = revealedContacts[record.id]?.email;
          const isEmailRevealed = revealedContacts[record.id]?.email || record.isEmail;

          const corporate_phone_placeholder = 'XXXXXXXXXXXX'; // Initial placeholder
          const mobile_phone_placeholder = 'View mobile phone'; // Placeholder after corporate phone is revealed

          return (
            <Tooltip
              title={
                isCorporatePhoneRevealed || isEmailRevealed ? (
                  field === 'mobile_phone' ? (
                    <>
                      {record['corporate_phone'] || 'Not Found'}
                      <br />
                      {isMobileRevealed ? text : mobile_phone_placeholder}
                      <br />
                      {isMobileRevealed ? record['work_direct_phone'] || 'Not Found' : ''}
                    </>
                  ) : (
                    <>{text}</>
                  )
                ) : (
                  'Click to reveal'
                )
              }
            >

              {field=="email" && (
                <span
                  
                  style={{
                    cursor: 'pointer',
                    color: isCorporatePhoneRevealed || isEmailRevealed || isMobileRevealed ? 'inherit' : '#1890ff',
                  }}
                >
                 {
  isEmailRevealed ? (
    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      {text}
      <CopyOutlined
        onClick={() => handleCopy(text)}
        style={{ cursor: 'pointer', color: '#9856f2' }}
      />
    </span>
  ) : (
    <button
      onClick={() => !isFieldLoading(record.id, 'email') && handleReveal(record.id, field, text)}
      disabled={isFieldLoading(record.id, 'email')}
      className="color-table-text-active"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        background: 'none',
        border: '1px solid #9856f2',
        borderRadius: 5,
        padding: '2px 10px',
        cursor: isFieldLoading(record.id, 'email') ? 'not-allowed' : 'pointer',
        textDecoration: 'none',
      }}
    >
      {isFieldLoading(record.id, 'email') ? 'fetching...' : (<>
        <MailTwoTone style={{ color: '#9856f2'  }} twoToneColor="#9856f2" />
        Click to reveal
      </>)}
    </button>
  )
}
                </span>
              )}


{field=="mobile_phone" && (
             <button
             onClick={() => !isFieldLoading(record.id, 'mobile_phone') && showRevealModal(record)}
             disabled={isFieldLoading(record.id, 'mobile_phone')}
             className="color-table-text-active"
             style={{
               display: 'flex',
               alignItems: 'center',
               gap: '6px',
               background: 'none',
               border: '1px solid #9856f2',
               borderRadius:5,
               padding: "2px 10px",
               cursor: isFieldLoading(record.id, 'mobile_phone') ? 'not-allowed' : 'pointer',
               color: isCorporatePhoneRevealed || isEmailRevealed || isMobileRevealed ? 'inherit' : '#1890ff',
               textDecoration: "none"
             }}
           >
             {isFieldLoading(record.id, 'mobile_phone') ? 'fetching...' : (<>
               <PhoneTwoTone style={{color: "#9856f2"}} twoToneColor="#9856f2" />
               Click to reveal
             </>)}
           </button>
               )}  
            </Tooltip>
             
          );
        }
        
        

       

        if(field==="title" || field==="country"){
          return (
            <Tooltip title={text}>
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',maxWidth: 300 }}>
                <span className='color-table-text'>{text}</span>
              </div>
            </Tooltip>
          );
        }

        const isBlurred = shouldBlur && !(revealedContacts[record.id]?.email || revealedContacts[record.id]?.mobile_phone || record.isEmail || record.isMobile);
        return (
          <Tooltip title={isBlurred ? '' : text}>
            <div
              className='color-table-text'
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: 300,
                filter: isBlurred ? 'blur(5px)' : 'none',
                userSelect: isBlurred ? 'none' : 'auto'
              }}
            >
              {isBlurred ? maskValue(text) : text}
            </div>
          </Tooltip>
        );
      },
    });
  });

  if(role === 'admin'){
  columns.push({
  title: 'Action',
  key: 'action',
  fixed: 'right',
  width: 100,
  render: (_, record) => (
    <Button
      type="link"
      onClick={() => showEditModal(record)}
    >
      Edit
    </Button>
  ),
});
  }

  return columns;
};

export default function LeadsTable({ data, selectedKeys, handleSelect, handleSelectAll, loading, selectedFields, fetchData,getRemainingCredit,allSelectOptionAllowed }) {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [revealedContacts, setRevealedContacts] = useState({});
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isRevealModalVisible, setIsRevealModalVisible] = useState(false);
  const [revealLoadingMap, setRevealLoadingMap] = useState({});
  const [form] = Form.useForm();

  const setFieldLoading = (id, field, value) => {
    setRevealLoadingMap(prev => ({
      ...prev,
      [id]: {
        ...(prev[id] || {}),
        [field]: value,
      }
    }));
  };

  const isFieldLoading = (id, field) => !!(revealLoadingMap[id] && revealLoadingMap[id][field]);

  const handleNameClick = (record) => {
    setSelectedLead(record);
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
    setSelectedLead(null);
  };

  const handleCopy = (text) => {
    message.success("Copied !")
    navigator.clipboard.writeText(text);
  };

  const handleReveal = async (id, field, originalValue) => {
    if (revealedContacts[id]?.[field]) return;

    
    setSelectedLead(data.find(lead => lead.id === id));
    // If the contact value is not available, don't deduct credits
    if (!originalValue) {
      message.warning('Contact not available');
      return;
    }

    // set per-field loader and open modal for mobile
    setFieldLoading(id, field, true);
    if (field === 'mobile_phone') {
      setIsRevealModalVisible(true);
    }
    handleSavedLeadsOk(id,field);

    

    const token = sessionStorage.getItem('access_token');
    const credit_deduct = field === 'email' ? 1  : 6;
   


    try {
      const response = await fetch("https://api.app.exellius.com/api/leads/deductCreditsFromUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + token,
        },
        body: JSON.stringify({ count: credit_deduct }),
      });

      const result = await response.json();

      if (response.ok) {

        setRevealedContacts(prev => ({
          ...prev,
          [id]: { ...prev[id], [field]: originalValue },
        }));

        setFieldLoading(id, field, false);

        getRemainingCredit();
      } else {

        message.warning("You do not have enough credits");
        setFieldLoading(id, field, false);
        
      }
    } catch (error) {
     
      setFieldLoading(id, field, false);
      alert("Something went wrong. Please try again.");
    }
  };

  const showEditModal = (record) => {
    setSelectedLead(record);
    form.setFieldsValue(record);
    setIsEditModalVisible(true);
  };

  const handleEditCancel = () => {
    setIsEditModalVisible(false);
    setSelectedLead(null);
  };

  const handleEditOk = async () => {
    try {
      const values = await form.validateFields();
      const token = sessionStorage.getItem('access_token');
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const encryptedData = encryptData({ ...values, id: selectedLead.id });

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify({ data: encryptedData }),
        redirect: "follow"
      };

      const response = await fetch("https://api.app.exellius.com/api/leads/editPeopleLeadsData", requestOptions);
      const result = await response.json();

      if (response.ok) {
        const decryptedResponse = decryptData(result.data);
        message.success("Lead updated successfully");
        setIsEditModalVisible(false);
        setSelectedLead(null);
        fetchData();
      } else {
        message.error(result.message || "Failed to update lead");
      }
    } catch (error) {
      
      message.error("An error occurred while updating the lead");
    }
  };

  const fetchSavedLeads = () => {
       
          const token = sessionStorage.getItem('access_token');
          const myHeaders = new Headers();

          
          myHeaders.append(
            "Authorization",
            `Bearer ${token}`
          );
      
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };
      
          fetch(`https://api.app.exellius.com/api/leads/getSavedLeads?page=1&limit=1000`, requestOptions)
            .then(response => response.json())
            .then(data => {
               const decryptedResponse = decryptData(data.data);
               const newItems = decryptedResponse.data;

               setRevealedContacts(prev => {
  // Create a copy of the previous state
  const updatedState = { ...prev };

  newItems.forEach(item => {
    const id = item.id;
    
    // Initialize the object for this ID if it doesn't exist
    updatedState[id] = {
      ...updatedState[id],
      // Map the API fields to your state fields
      // Using '||' ensures we don't overwrite existing revealed data with null
      email: item.isEmail || updatedState[id]?.email,
      mobile_phone: item.isMobile || updatedState[id]?.mobile_phone,
      corporate_phone: item.isCorporatePhone || updatedState[id]?.corporate_phone
    };
  });

  return updatedState;
});

              
            })
            .catch(error => {
              console.error("Error fetching saved leads:", error);
             
            });
        
      };

  const showRevealModal = (record) => {
    setSelectedLead(record);
    setIsRevealModalVisible(true);
  };

  fetchSavedLeads();

  const dataWithFullName = data.map((item) => ({
    ...item,
    name: `${item.first_name} ${item.last_name}`,
  }));

  return (
    <>
      <Table
        columns={getColumns(selectedFields, selectedKeys, handleSelect, handleSelectAll, handleNameClick, handleReveal, revealedContacts, handleCopy, showEditModal, showRevealModal, allSelectOptionAllowed, revealLoadingMap)}
        dataSource={dataWithFullName}
        rowKey="id"
        loading={loading}
        pagination={false}
        scroll={{ x: 'max-content', y: 'calc(125vh - 312px)' }}
        bordered
      />
      <Drawer
        title="Lead Details"
        placement="right"
        onClose={handleDrawerClose}
        visible={drawerVisible}
        width={600}
      >
      {selectedLead && (
  <div>
    {/* Profile Section */}
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
      <Avatar size={48} style={{ marginRight: 12 }}>
        {selectedLead.first_name?.charAt(0) || '?'}
      </Avatar>
      <div>
        <strong style={{ fontSize: '16px' }}>
          {selectedLead.first_name + " " + selectedLead.last_name || 'Not Found'}
        </strong>
        <br />
        <span style={{ color: '#888' }}>{selectedLead.title || 'Not Found'}</span>
      </div>
    </div>

    <Tabs defaultActiveKey="1">
      <TabPane tab="Contact Information" key="1">
        <p><strong>Full Name:</strong><br />
          <Tag>
            {selectedLead.first_name + ' ' + selectedLead.last_name || 'Not Found'}
          </Tag>
          {selectedLead.linkedin_url && (
            <a href={selectedLead.linkedin_url} target="_blank" rel="noopener noreferrer">
              <LinkedinFilled style={{ fontSize: '14px' }} />
            </a>
          )}
        </p>

        


        <p><strong>Email:</strong><br />
          {revealedContacts[selectedLead.id]?.email || selectedLead.isEmail ? (
            <Tag color="blue">{selectedLead.email || <span style={{ color: 'red' }}>Not Found</span>}</Tag>
          ) : (
            <Tag color="blue" onClick={() => handleReveal(selectedLead.id, 'email', selectedLead.email)} style={{ cursor: 'pointer' }}>
              ●●●●●●@***.com
            </Tag>
          )}
        </p>


        <p><strong>Email Status:</strong><br />
          <Tag>
            {selectedLead.email_status ? selectedLead.email_status : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>



        {/* Corporate Phone */}
        <p><strong>Corporate Phone:</strong><br />
          {revealedContacts[selectedLead.id]?.email || selectedLead.isEmail ? (
            <Tag color="blue">{isFieldLoading(selectedLead.id, 'email') ? 'fetching...' : (selectedLead.corporate_phone || <span style={{ color: 'red' }}>Not Found</span>)}</Tag>
          ) : (
            <Tag color="blue" onClick={() => handleReveal(selectedLead.id, 'email', selectedLead.email)} style={{ cursor: 'pointer' }}>
              {isFieldLoading(selectedLead.id, 'email') ? 'fetching...' : '+XX-XXXX-XXXX'}
            </Tag>
          )}
        </p>

        {/* Show Mobile Button if email is revealed but mobile is not */}
        {(revealedContacts[selectedLead.id]?.email || selectedLead.isEmail) &&
         (!revealedContacts[selectedLead.id]?.mobile_phone && !selectedLead.isMobile) && (
          <Button size="small" loading={isFieldLoading(selectedLead.id, 'mobile_phone')} onClick={() => handleReveal(selectedLead.id, 'mobile_phone', selectedLead.mobile_phone)} style={{ marginTop: 0,marginBottom:20 }}>
            Show Mobile Number
          </Button>
        )}

        {/* Mobile Phone */}
        {(revealedContacts[selectedLead.id]?.mobile_phone || selectedLead.isMobile) ? (
          <p><strong>Mobile Phone:</strong><br />
            <Tag color="green">{isFieldLoading(selectedLead.id, 'mobile_phone') ? 'fetching...' : (selectedLead.mobile_phone || <span style={{ color: 'red' }}>Not Found</span>)}</Tag>
          </p>
        ) : null}

        {/* Show Work Direct Button if mobile is revealed but work direct is not */}
        

        {/* Work Direct Phone */}
        {(revealedContacts[selectedLead.id]?.mobile_phone || selectedLead.isMobile) ? (
          <p><strong>Work Direct Phone:</strong><br />
            <Tag color="green">{isFieldLoading(selectedLead.id, 'mobile_phone') ? 'fetching...' : (selectedLead.work_direct_phone || <span style={{ color: 'red' }}>Not Found</span>)}</Tag>
          </p>
        ) : null}
       
        <p><strong>Job Title:</strong><br />
          <Tag>
            {selectedLead.title ? selectedLead.title : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>
        <p><strong>City:</strong><br />
          <Tag>
            {selectedLead.city ? selectedLead.city : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>
        <p><strong>Location:</strong><br />
          <Tag>
            {selectedLead.country ? selectedLead.country : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>
        <p><strong>Seniority:</strong><br />
          <Tag>
            {selectedLead.seniority ? selectedLead.seniority : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>
        <p><strong>Departments:</strong><br />
          <Tag>
            {selectedLead.departments ? selectedLead.departments : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>
      </TabPane>

      <TabPane tab="Company Information" key="2">
        <p><strong>Company:</strong><br />
          <Tag>
            {selectedLead.company ? selectedLead.company : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
          {selectedLead.company_linkedin_url && (
            <a href={selectedLead.company_linkedin_url} target="_blank" rel="noopener noreferrer">
              <LinkedinFilled style={{ fontSize: '14px' }} />
            </a>
          )}
        </p>

        <p><strong>Company Address:</strong><br />
          <Tag>
            {selectedLead.company_address ? selectedLead.company_address : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>

        <p><strong>Industry:</strong><br />
          <Tag>
            {selectedLead.industry ? selectedLead.industry : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>

        <p><strong>Number of Employees:</strong><br />
          <Tag>
            {selectedLead.num_employees ? selectedLead.num_employees : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>

        <p><strong>Website:</strong><br />
          <Tag>
            {selectedLead.website ? (
              <a href={selectedLead.website} target="_blank" rel="noopener noreferrer">
                {selectedLead.website}
              </a>
            ) : (
              <span style={{ color: 'red' }}>Not Found</span>
            )}
          </Tag>
        </p>

        <p><strong>Technologies:</strong><br />
          <Tag>
            {selectedLead.technologies ? (
              selectedLead.technologies.split(',').map((tech, index) => (
                <Tag key={index}>{tech.trim()}</Tag>
              ))
            ) : (
              <span style={{ color: 'red' }}>Not Found</span>
            )}
          </Tag>
        </p>

        <p><strong>SEO Description:</strong><br />
          <Tag style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}>
            {selectedLead.seo_description ? selectedLead.seo_description : <span style={{ color: 'red' }}>Not Found</span>}
          </Tag>
        </p>
      </TabPane>
    </Tabs>
  </div>
)}


      </Drawer>
      <Modal
        title="Edit Lead"
        visible={isEditModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        okText="Save"
      >
        <div className='modal-edit-container'>
        <Form form={form} layout="vertical">
          <Form.Item name="first_name" label="First Name" rules={[{ required: true, message: 'Please input the first name!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="last_name" label="Last Name" rules={[{ required: true, message: 'Please input the last name!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="title" label="Title" rules={[{ required: true, message: 'Please input the title!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="company" label="Company" rules={[{ required: true, message: 'Please input the company!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="email" label="Email" rules={[{ required: true, message: 'Please input the email!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="email_status" label="Email Status" rules={[{ required: true, message: 'Please input the email status!' }]}>
            <Select>
              <Option value="Verified">Verified</Option>
              <Option value="Unverified">Unverified</Option>
            </Select>
          </Form.Item>
          <Form.Item name="seniority" label="Seniority" rules={[{ required: true, message: 'Please input the seniority!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="departments" label="Departments" rules={[{ required: true, message: 'Please input the departments!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="work_direct_phone" label="Work Direct Phone">
            <Input />
          </Form.Item>
          <Form.Item name="mobile_phone" label="Mobile Phone">
            <Input />
          </Form.Item>
          <Form.Item name="corporate_phone" label="Corporate Phone">
            <Input />
          </Form.Item>
          <Form.Item name="phone" label="Phone">
            <Input />
          </Form.Item>
          <Form.Item name="category" label="Category">
            <Input />
          </Form.Item>
          <Form.Item name="organization" label="Organization">
            <Input />
          </Form.Item>
          <Form.Item name="position" label="Position">
            <Input />
          </Form.Item>
          <Form.Item name="country" label="Country" rules={[{ required: true, message: 'Please input the country!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="city" label="City" rules={[{ required: true, message: 'Please input the city!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="state" label="State" rules={[{ required: true, message: 'Please input the state!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="company_address" label="Company Address">
            <Input />
          </Form.Item>
          <Form.Item name="company_city" label="Company City">
            <Input />
          </Form.Item>
          <Form.Item name="company_state" label="Company State">
            <Input />
          </Form.Item>
          <Form.Item name="company_country" label="Company Country">
            <Input />
          </Form.Item>
          <Form.Item name="industry" label="Industry" rules={[{ required: true, message: 'Please input the industry!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="num_employees" label="Number of Employees">
            <Input />
          </Form.Item>
          <Form.Item name="linkedin_url" label="LinkedIn URL">
            <Input />
          </Form.Item>
          <Form.Item name="website" label="Website">
            <Input />
          </Form.Item>
          <Form.Item name="company_linkedin_url" label="Company LinkedIn URL">
            <Input />
          </Form.Item>
          <Form.Item name="facebook_url" label="Facebook URL">
            <Input />
          </Form.Item>
          <Form.Item name="twitter_url" label="Twitter URL">
            <Input />
          </Form.Item>
          <Form.Item name="keywords" label="Keywords">
            <Input />
          </Form.Item>
          <Form.Item name="technologies" label="Technologies">
            <Input />
          </Form.Item>
          <Form.Item name="seo_description" label="SEO Description">
            <Input />
          </Form.Item>
          <Form.Item name="annual_revenue" label="Annual Revenue">
            <Input />
          </Form.Item>
          <Form.Item name="total_funding" label="Total Funding">
            <Input />
          </Form.Item>
          <Form.Item name="latest_funding" label="Latest Funding">
            <Input />
          </Form.Item>
          <Form.Item name="latest_funding_amount" label="Latest Funding Amount">
            <Input />
          </Form.Item>
          <Form.Item name="last_raised_at" label="Last Raised At">
            <Input />
          </Form.Item>
          <Form.Item name="num_retail_locations" label="Number of Retail Locations">
            <Input />
          </Form.Item>
        </Form>
        </div>
      </Modal>


      
      <Modal
  title="Contact numbers details"
  visible={isRevealModalVisible}
  onCancel={() => setIsRevealModalVisible(false)}
  footer={[
    <Button key="close" type="primary" onClick={() => setIsRevealModalVisible(false)}>
      Close
    </Button>
  ]}
>
  {selectedLead && (
    <div style={{ marginTop: 20 }}>
      {/* Corporate Phone */}
      <p>
        <strong>Corporate Phone:</strong><br />
        {revealedContacts[selectedLead.id]?.email || selectedLead.isEmail ? (
          selectedLead.corporate_phone ? (
            <Tag color="blue" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              {isFieldLoading(selectedLead.id, 'email') ? 'fetching...' : selectedLead.corporate_phone}
              <CopyOutlined
                onClick={() => handleCopy(selectedLead.corporate_phone)}
                style={{ cursor: 'pointer' }}
              />
            </Tag>
          ) : (
            <Tag color="blue"><span style={{ color: 'red' }}>Not Found</span></Tag>
          )
        ) : (
          <Tag
            color="blue"
            onClick={() => handleReveal(selectedLead.id, 'email', selectedLead.email)}
            style={{ cursor: 'pointer' }}
          >
            {isFieldLoading(selectedLead.id, 'email') ? 'fetching...' : '+XX-XXXX-XXXX'}
          </Tag>
        )}
      </p>

      {/* Mobile Phone */}
<p>
  <strong>Mobile Phone:</strong><br />

  {revealedContacts[selectedLead.id]?.mobile_phone || selectedLead.isMobile ? (
    selectedLead.mobile_phone ? (
      <Tag color="green" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        {isFieldLoading(selectedLead.id, 'mobile_phone') ? 'fetching...' : selectedLead.mobile_phone}
        <CopyOutlined
          onClick={() => handleCopy(selectedLead.mobile_phone)}
          style={{ cursor: 'pointer' }}
        />
      </Tag>
    ) : (
      <Tag color="green"><span style={{ color: 'red' }}>Not Found</span></Tag>
    )
  ) : (
    <Tag
      color="green"
      onClick={() =>
        handleReveal(selectedLead.id, 'mobile_phone', selectedLead.mobile_phone)
      }
      style={{ cursor: 'pointer' }}
    >
      {isFieldLoading(selectedLead.id, 'mobile_phone') ? 'fetching...' : '+XX-XXXX-XXXX'}
    </Tag>
  )}
</p>

{/* Work Direct Phone */}
<p>
  <strong>Work Direct Phone:</strong><br />

  {revealedContacts[selectedLead.id]?.mobile_phone || selectedLead.isMobile ? (
    selectedLead.work_direct_phone ? (
      <Tag color="green" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        {isFieldLoading(selectedLead.id, 'mobile_phone') ? 'fetching...' : selectedLead.work_direct_phone}
        <CopyOutlined
          onClick={() => handleCopy(selectedLead.work_direct_phone)}
          style={{ cursor: 'pointer' }}
        />
      </Tag>
    ) : (
      <Tag color="green"><span style={{ color: 'red' }}>Not Found</span></Tag>
    )
  ) : (
    <Tag
      color="green"
      onClick={() =>
        handleReveal(selectedLead.id, 'mobile_phone', selectedLead.mobile_phone)
      }
      style={{ cursor: 'pointer' }}
    >
      {isFieldLoading(selectedLead.id, 'mobile_phone') ? 'fetching...' : '+XX-XXXX-XXXX'}
    </Tag>
  )}
</p>

      
    </div>
  )}
</Modal>

    </>
  );
}
